import { Box } from '@mui/material'

// Same visually-hidden styles as the SpeechToText live region.
const visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0,0,0,0)',
  whiteSpace: 'nowrap',
  border: 0,
} as const

/**
 * What a request row's scan announcement should say. Only scans this browser
 * is tracking produce text, so a page load announces nothing.
 */
export function scanAnnouncement({
  title,
  isScanning,
  scanError,
  latestStatus,
  latestScanFoundNothing,
}: {
  title: string
  isScanning: boolean
  scanError: string | null
  latestStatus: string
  latestScanFoundNothing: boolean
}): string {
  if (isScanning) return `Finding matches for ${title}`
  if (scanError) return `Scan failed for ${title}`
  if (latestStatus !== 'completed') return ''
  return latestScanFoundNothing
    ? `No matches found for ${title}`
    : `Scan complete for ${title}`
}

/**
 * Screen-reader announcement of a row's scan outcome. The region stays
 * mounted and only its text changes, since a live region inserted with its
 * text already inside is not reliably announced.
 */
export function ScanStatusAnnouncer({ message }: { message: string }) {
  return (
    <Box role="status" aria-live="polite" aria-atomic="true" sx={visuallyHidden}>
      {message}
    </Box>
  )
}
